import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { soundClipApi } from '~/apis/soundClipApi'
import { useUserState } from '~/atoms/UserState'
import { ApplicationRoutes } from '~/hooks/useRouting'

import {
  SoundClipCreatePage,
  SoundClipEditPage,
  SoundClipListPage,
} from '@mangovoice/soundclips-ui'
import type { SoundClip } from '@mangovoice/soundclips-ui'

interface SoundClipSettingsPageProps {
  soundClipId?: string
  isCreating?: boolean
}

export const SoundClipSettingsPage = ({
  soundClipId,
  isCreating,
}: SoundClipSettingsPageProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pbxId } = useUserState({ canAutoRefresh: false })

  if (!pbxId) {
    return null
  }

  const basePath = `${ApplicationRoutes.SETTINGS}/sound-clips`

  const handleRowClick = (clip: SoundClip) => {
    navigate(`${basePath}/${clip.id}`)
  }

  const handleBack = () => {
    navigate(basePath)
  }

  if (isCreating) {
    return (
      <SoundClipCreatePage
        api={soundClipApi}
        pbxId={pbxId}
        onBack={handleBack}
        t={t}
      />
    )
  }

  if (soundClipId) {
    return (
      <SoundClipEditPage
        api={soundClipApi}
        pbxId={pbxId}
        soundClipId={Number(soundClipId)}
        onBack={handleBack}
        onDeleted={handleBack}
        t={t}
      />
    )
  }

  return (
    <SoundClipListPage
      api={soundClipApi}
      pbxId={pbxId}
      onRowClick={handleRowClick}
      onCreateClick={() => navigate(`${basePath}/new`)}
      t={t}
    />
  )
}
